import Avatar from 'react-avatar';
import ReadMore from '../../../../components/Common/ReadMore';
import { ImageFileUtil } from '../../../../utils';

function SelfRatingComment({ selectedKPI, performanceHeader }) {
  const header = performanceHeader?.[0];
  const getImage = () => {
    if (header?.Imagefile) {
      return ImageFileUtil.getEmployeeFilePath(header?.Imagefile);
    }
    return null;
  };

  return (
    <div className="comments pt-2">
      <div className="comment">
        <Avatar
          name={header?.EmpName || 'Unknown'}
          size="32px"
          color="#CFCBDC"
          fgColor="#475467"
          style={{
            fontSize: '14px',
            fontWeight: '600',
          }}
          src={getImage()}
          round
        />
        <div className="commentContent">
          <div className="title">{header?.EmpName?.trim()} (Employee)</div>
          <div className="per-description fs-6">
            <ReadMore htmlString={selectedKPI?.Rating_Self_Comments} />
          </div>
        </div>
      </div>
    </div>
  );
}

export default SelfRatingComment;
